const V1_CURL_PARTS = {
  before: `curl --request POST \\
    --url https://api.kycaml.uat.frankiefinancial.io/compliance/v1.2/entity \\
    --header 'api_key: your_uat_api_key' \\
    --header 'X-Frankie-CustomerID: your_customer_id' \\`,
  childLine: `    --header 'X-Frankie-CustomerChildID: your_child_id' \\`,
  after: `    --header 'Content-Type: application/json' \\
    --data '{
      "entityType": "INDIVIDUAL",
      "name": {
        "givenName": "JAMES",
        "middleName": "A",
        "familyName": "TESTONE"
      },
      "dateOfBirth": { "dateOfBirth": "1980-01-01" },
      "addresses": [
        {
          "country": "AUS",
          "postalCode": "2000",
          "state": "NSW",
          "streetName": "Test Street",
          "streetNumber": "1",
          "streetType": "ST",
          "suburb": "SYDNEY",
          "unitNumber": "1"
        }
      ]
    }'`,
};

const V2_CURL_PARTS = {
  before: `curl --request POST \\
    --url https://api.uat.frankie.one/v2/individuals \\
    --header 'api_key: your_uat_api_key' \\
    --header 'X-Frankie-CustomerID: your_customer_id' \\`,
  childLine: `    --header 'X-Frankie-CustomerChildID: your_child_id' \\`,
  after: `    --header 'Content-Type: application/json' \\
    --data '{
      "individual": {
        "name": {
          "givenName": "JAMES",
          "middleName": "A",
          "familyName": "TESTONE"
        },
        "dateOfBirth": {
          "year": "1950",
          "month": "01",
          "day": "01"
        },
        "gender": {
          "gender": "MALE"
        },
        "addresses": [
          {
            "addressType": "RESIDENTIAL",
            "streetAddress": "35 CONN STREET",
            "locality": "FERNTREE GULLY",
            "subdivision": "VIC",
            "postalCode": "3156",
            "country": "AUS"
          }
        ]
      }
    }'`,
};

export default function PinnedCurl({ apiVersion = "v1" }: { apiVersion?: string }) {
  const parts = apiVersion === "v2" ? V2_CURL_PARTS : V1_CURL_PARTS;

  return (
    <div style={{ background: "#fff8e1", border: "1px solid #f0c040", borderRadius: 6, padding: "12px 14px", marginTop: 18 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: "#b7791f", marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
        <span>📋</span> Try it yourself — Create Entity (UAT)
        <span style={{ marginLeft: "auto", fontSize: 10, fontWeight: 400, color: "#999" }}>
          Replace api_key and CustomerID with your credentials — entity appears in portal immediately
        </span>
      </div>
      <pre style={{ background: "#1e293b", color: "#93c5fd", padding: "12px 14px", borderRadius: 5, margin: 0, fontSize: "0.82em", overflowX: "auto", lineHeight: 1.7 }}><code>{parts.before}{"\n"}<span className="child-id-only">{parts.childLine}{"\n"}</span>{parts.after}</code></pre>
      <div style={{ fontSize: 10, color: "#92400e", marginTop: 7 }}>
        Uses the official <strong>JAMES A TESTONE</strong> testbed persona. A{" "}
        <code style={{ background: "#fef3c7", padding: "1px 4px", borderRadius: 2 }}>200 OK</code> with an{" "}
        <code style={{ background: "#fef3c7", padding: "1px 4px", borderRadius: 2 }}>entityId</code>{" "}
        confirms credentials are valid.
        <span className="child-id-only">
          {" "}⚠️ Child ID active — a separate{" "}
          <code style={{ background: "#fef3c7", padding: "1px 4px", borderRadius: 2 }}>api_key</code>{" "}
          is required per child.
        </span>
      </div>
    </div>
  );
}
